module.exports = __webpack_public_path__ + "img/remote-tablet.645aa153.png";